import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Field } from 'kts-scaffold-framework/utils/doc';
 
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}


/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}
const ColorBox = ({num}) =>{
    if (parseFloat(num) > 0) {
        return <span style={{color: 'blue'}}>{num}</span>;
    } else if (parseFloat(num) < 0) {
        return <span style={{color: 'red'}}> {num}</span>;
    } else  {
        return <span style={{color: 'gray'}}>{num}</span>;
    }
};

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class Footer  extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const {
            amountMatchedTolerance,
            amountMatchedTaxTolerance,
            amountSum,
            amountTax,
            amountWithoutTax,
        } = this.modulesState.statistics;
        //已匹配金额
        const {
            matchedAmountTax,
            matchedAmountSum,
            matchedAmountWithoutTax,
            matchedLength,
        } = this.modulesState;
        console.log('12121212',this.modulesState.statistics.amountWithoutTax);
        return (
            <div className={css['input-settlement-footer']}>
            <div className={css['match-footer']}>
                <div className={css['match-item']}>
                <div>
                        已勾选金额：
                        <span>{Field.formatMoney(matchedAmountWithoutTax, 2)}</span>
                    </div>
                    <div>
                        差异： 
                            {/* <span>{diffAmountWithoutTax}</span> */}
                        {/* <ColorBox num={(amountMatchedTolerance-amountMatchedTaxTolerance).toFixed(2)}/> */}
                        <ColorBox num={(amountWithoutTax-matchedAmountWithoutTax).toFixed(2)}/>
                    </div>
                </div>
                <div className={css['match-item']}>
                    <div>
                        已勾选税额：<span>{Field.formatMoney(matchedAmountTax, 2)}</span>
                    </div>
                    <div>
                        差异： 
                        <ColorBox num={(amountTax-matchedAmountTax).toFixed(2)} />
                    </div>
                </div>
                <div className={css['match-item']}>
                    <div>
                        已勾选价税合计：<span>{Field.formatMoney(matchedAmountSum, 2)}</span>
                    </div>
                    <div>
                        差异：
                        <ColorBox num={(amountSum-matchedAmountSum).toFixed(2)} />
                    </div>
                </div>
                <div className={css['match-item']} style={{borderRight: 'none',paddingRight: 10}}>
                    已匹配发票张数：<span>{matchedLength}</span>
                </div>
            </div>
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/InputSettlement/UI.ViewMatch.Footer.tsx